import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Project } from './project.model';
import { ProjectService } from './project.service';

export function disabledPageGuard(pageKey: string): CanActivateFn {
  return () => {
    const projectService = inject(ProjectService);
    const router = inject(Router);

    const project = projectService.getProject() as Project;

    if (project?.config?.disabledPages?.includes(pageKey)) {
      return router.createUrlTree(['/disabled', pageKey]);
    }

    return true;
  };
}
